import styled from 'styled-components';

export const SubtotalStyles = styled.div`
	display: flex;
	flex-direction: column;
	gap: 12px;

	.subtitle {
		svg {
			flex-shrink: 0;
		}
	}
`;

export const RateSectionContainerStyles = styled.div`
	display: flex;
	flex-direction: column;
	gap: 8px;

	button {
		align-self: flex-start;
	}
`;
